export default "__VITE_ASSET__1aBPfu2$__"